import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnDestroy,
  ViewChild
} from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { columns } from './columns';

import { FrontendSearchWidgetComponent } from 'shared/search-widget/frontend-search-widget.component';
import { HiddenScrollComponent } from 'shared/scroll/hidden-scroll/hidden-scroll.component';

import { ListManagerService } from 'shared/list-manager/list-manager.service';
import {ProductPanelComponent} from '../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'product-lists-search',
  templateUrl: 'product-lists-search.component.html',
  styleUrls: ['product-lists-search.component.scss'],
  providers: [
    {provide: 'LIST_TYPE', useValue: 'item'},
    ListManagerService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductListsSearchComponent extends FrontendSearchWidgetComponent {

  @Output() backToProducts: EventEmitter<string> = new EventEmitter();

  @ViewChild(HiddenScrollComponent, {static: false})
  hiddenScroll: HiddenScrollComponent | void;

  columns: any = columns;
  ghostValue: string = 'product-list';

  get selectedIds(): Array<any> {
    return _.map(this.selected, (item: any) => item._id);
  }

  get filteredIds(): Array<any> {
    return _.map(this.filterByField(this.data), (item: any) => item._id);
  }

  constructor(
    private listService: ListManagerService,
    private ref: ChangeDetectorRef,
  ) {
    super();
  }

  fetchLists(): void {
    this.listService.fetch()
    .subscribe((data: Array<any>) => {
      this.data = data;
      _.defer(() => {
        if (this.hiddenScroll) {
          this.hiddenScroll.defineContentWidth();
        }
        this.ref.markForCheck();
      });
    });
  }

  // handlers
  onBackToProductsClick() {
    this.backToProducts.emit();
  }
}
